'use strict';

var internals = {};

module.exports = function (promise) {
  return !!promise && typeof promise.then === 'function';
};